<template>
	<v-card :class="isFixed ? 'fixedCard' : 'my-2'">
		<v-layout row wrap>
			<v-icon v-if="isFixed" @click="goBack" color="#000"
				>chevron_left</v-icon
			>
			<v-flex class="pa-2">
				<div class="retailerName">
					{{
						associateData.retailerName ||
							associateData.name ||
							associateData.teamName ||
							"-"
					}}
				</div>
				<div class="my-1">
					<v-icon small>phone</v-icon
					><span class="phoneNumber ml-1">{{
						(associateData.phoneNo || "").toString().substr(2)
					}}</span>
				</div>
				<div class="my-1">
					{{
						getFrontendStoreType(
							associateData.userType,
							associateData.shopType
						) || "Jeet11 User"
					}}
				</div>
			</v-flex>
			<div class="walletBalance">
				<div
					class="px-3 allCenteredChild"
					:style="{ background: jeet11Color, height: 100 + '%' }"
				>
					{{ associateData.walletBalance || 0 }}
				</div>
				<div
					v-if="associateData.hasOwnProperty('gameWalletBalance')"
					class="px-3 allCenteredChild"
					:style="{
						background: rummyColor,
						height: 100 + '%'
					}"
				>
					{{ associateData.gameWalletBalance || 0 }}
				</div>
			</div>
			<v-flex
				v-if="!isFixed && associateData.hasOwnProperty('userType')"
				xs1
				text-xs-center
				style="align-self:center;cursor: pointer;"
				@click="onClick(associateData)"
				><v-card-text class="px-0"
					><v-icon color="#000">chevron_right</v-icon></v-card-text
				></v-flex
			>
		</v-layout>
		<div>
			<div
				class="metrics text-xs-center ml-2"
				@click="showMetrics(associateData.userId)"
			>
				<div>Metric Details</div>
				<div class="ml-1">
					<v-icon color="#000">{{
						openMetricDetails ? "expand_less" : "expand_more"
					}}</v-icon>
				</div>
			</div>
			<div v-if="openMetricDetails && !isDataLoading">
				<div>
					<v-tabs
						v-model="activeTab"
						:color="themeInputColor"
						dark
						slider-color="yellow"
						grow
					>
						<v-tab
							v-for="(tab, i) in tabs"
							:key="i"
							:href="'#tab-' + i"
							:ripple="false"
							class="px-3"
						>
							{{ tab.name }}
						</v-tab>
					</v-tabs>
					<v-tabs-items v-model="activeTab">
						<v-tab-item value="tab-0">
							<v-card flat>
								<v-card-text>
									<v-data-table
										:items="
											keysFilteration(
												Object.keys(
													totalData.total[0] || {}
												).sort(keyA => {
													if (
														this.priorityKeys.indexOf(
															keyA
														) !== -1
													) {
														return -1;
													}
													return 1;
												}),
												['daily', 'dau']
											)
										"
										class="elevation-1"
										:hide-actions="true"
										hide-headers
									>
										<template v-slot:items="props">
											<tr>
												<td>
													{{
														convertToReadableForm(
															props.item
														)
													}}
												</td>
												<td>
													{{
														totalData.total[0][
															props.item
														] || 0
													}}
												</td>
											</tr>
										</template>
									</v-data-table>
								</v-card-text>
							</v-card>
						</v-tab-item>
						<v-tab-item value="tab-1"
							><v-card flat>
								<v-card-text>
									<v-data-table
										:items="
											keysFilteration(
												Object.keys(
													totalData.endDate[0] || {}
												).sort(keyA => {
													if (
														this.priorityKeys.indexOf(
															keyA
														) !== -1
													) {
														return -1;
													}
													return 1;
												}),
												['monthly', 'mau']
											)
										"
										class="elevation-1"
										:hide-actions="true"
										hide-headers
									>
										<template v-slot:items="props">
											<tr>
												<td>
													{{
														convertToReadableForm(
															props.item
														)
													}}
												</td>
												<td>
													{{
														totalData.endDate[0][
															props.item
														] || 0
													}}
												</td>
											</tr>
										</template>
									</v-data-table>
								</v-card-text>
							</v-card></v-tab-item
						>
					</v-tabs-items>
				</div>
			</div>
			<div v-if="isDataLoading" class="text-xs-center">
				<v-progress-circular
					:indeterminate="true"
				></v-progress-circular>
			</div>
		</div>
	</v-card>
</template>
<script>
import infiniteScroll from "vue-infinite-scroll";
import { FETCH_METRICS_DATA } from "../../store/action-types";
import { THEME_INPUT_COLOUR } from "../constants";
import {
	getFrontendStoreType,
	convertToReadableForm,
	keysFilteration
} from "@/utils";
export default {
	name: "AssociateCard",
	props: ["associateData", "isFixed", "jeet11Color", "rummyColor"],
	directives: { infiniteScroll },
	data() {
		return {
			getFrontendStoreType: (v, shopType) =>
				getFrontendStoreType(v, shopType),
			convertToReadableForm: text => convertToReadableForm(text),
			keysFilteration: (keysArray, keysToBeFiltered) =>
				keysFilteration(keysArray, keysToBeFiltered),
			openMetricDetails: false,
			themeInputColor: THEME_INPUT_COLOUR,
			defaultData: { endDate: [], total: [] },
			totalData: { endDate: [], total: [] },
			isDataLoading: false,
			activeTab: "tab-0",
			tabs: [{ name: "MTD" }, { name: "Current Date" }],
			priorityKeys: [
				"gmv_offline_fantasy",
				"gmv_offline_rummy",
				"ludo_gmv_total"
			]
		};
	},
	methods: {
		goBack() {
			this.openMetricDetails = false;
			this.$emit("GO_BACK");
		},
		onClick() {
			this.openMetricDetails = false;
			if (!this.isFixed) {
				this.$emit("ON_CLICK");
			}
		},
		showMetrics(userId) {
			this.openMetricDetails = !this.openMetricDetails;
			if (this.isDataLoading || !this.openMetricDetails) {
				return;
			}
			this.isDataLoading = true;
			const startDate = new Date().toISOString().slice(0, 8) + "01";
			const endDate = new Date().toISOString().slice(0, 10);
			this.$store
				.dispatch(FETCH_METRICS_DATA.dispatch, {
					userId,
					startDate,
					endDate
				})
				.then(data => {
					const {
						aggregatable = this.defaultData,
						nonAggregatable = this.defaultData
					} = data.response;
					const aggregatableData = {
						...this.defaultData,
						...aggregatable
					};
					let mtdNonAggregatableData = {};
					let currentDateNonAggregatableData = {};
					Object.keys(nonAggregatable[0]).forEach(key => {
						if (key.startsWith("daily") || key.startsWith("dau")) {
							currentDateNonAggregatableData = {
								...currentDateNonAggregatableData,
								[key]: nonAggregatable[0][key]
							};
						} else if (
							key.startsWith("monthly") ||
							key.startsWith("mau")
						) {
							mtdNonAggregatableData = {
								...mtdNonAggregatableData,
								[key]: nonAggregatable[0][key]
							};
						}
					});
					this.totalData = {
						endDate: [
							{
								...aggregatableData.endDate[0],
								"gmv_excluding_7777_and_5500_%": `${Math.round(
									((aggregatableData.endDate[0]
										.gmv_excluding_7777_and_5550 || 0) /
										(aggregatableData.endDate[0]
											.gmv_offline_fantasy || Infinity)) *
										100 *
										100
								) / 100}%`,
								...currentDateNonAggregatableData
							}
						],
						total: [
							{
								...aggregatableData.total[0],
								"gmv_excluding_7777_and_5500_%": `${Math.round(
									((aggregatableData.total[0]
										.gmv_excluding_7777_and_5550 || 0) /
										(aggregatableData.total[0]
											.gmv_offline_fantasy || Infinity)) *
										100 *
										100
								) / 100}%`,
								...mtdNonAggregatableData
							}
						]
					};
				})
				.catch(err => console.log(err))
				.finally(() => {
					this.isDataLoading = false;
				});
		}
	}
};
</script>
<style scoped>
.retailerName {
	font-size: 18px;
}
.walletBalance {
	display: flex;
	color: #fff;
	font-size: 14px;
	flex-direction: column;
}
.phoneNumber {
	font-weight: 500;
	color: cornflowerblue;
}
.fixedCard {
	position: fixed;
	width: 100%;
	z-index: 1;
	align-items: center;
	background: #fff;
	max-width: 600px;
}
.metrics {
	display: flex;
	cursor: pointer;
	width: fit-content;
}
</style>
